import { LatLng } from '@/types/google/geometry';

export interface SearchParams {
  position: LatLng;
  searchTerm: string;
  placeType: string;
  pages: string;
  /**
   * D41c: Open Now is a server-side search input, so it belongs in the query
   * key — toggling it is a distinct search by construction rather than a
   * client-side transform of an already-fetched page.
   */
  openNow?: boolean;
}

export interface SearchLocationParams {
  locationPlaceId: string;
  searchTerm: string;
  placeType: string;
  pages: string;
  /** See `SearchParams.openNow`. */
  openNow?: boolean;
}

export interface AutocompleteParams {
  q?: string;
  name?: string;
  limit?: number;
  /** Optional latitude for location-biased results */
  lat?: number;
  /** Optional longitude for location-biased results */
  lng?: number;
}

export interface ExpandedSearchParams {
  searchId: string;
  k: number;
}

export const restaurantKeys = {
  all: ['restaurants'] as const,

  // Search queries
  searches: () => [...restaurantKeys.all, 'search'] as const,
  search: (params: SearchParams) => [...restaurantKeys.searches(), params] as const,
  searchByLocation: (params: SearchLocationParams) =>
    [...restaurantKeys.searches(), 'location', params] as const,
  expanded: (params: ExpandedSearchParams) =>
    [...restaurantKeys.searches(), 'expanded', params] as const,

  // Restaurant details
  details: () => [...restaurantKeys.all, 'detail'] as const,
  detail: (id: number) => [...restaurantKeys.details(), id] as const,

  // Ratings
  ratings: (restaurantId: number) =>
    [...restaurantKeys.detail(restaurantId), 'ratings'] as const,

  // Menu items
  menuItems: (restaurantId: number) =>
    [...restaurantKeys.detail(restaurantId), 'menu-items'] as const,

  // Autocomplete
  autocomplete: (params: AutocompleteParams) =>
    [...restaurantKeys.all, 'autocomplete', params] as const,

  // History
  history: () => [...restaurantKeys.all, 'history'] as const,

  // Pending images polling
  pendingImages: (ids: number[]) =>
    [...restaurantKeys.all, 'pending-images', ids] as const,
} as const;
